var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.7187C6.28054 28.7187 3.79755e-06 22.4382 2.44784e-06 14.7187C1.09812e-06 6.99929 6.28054 0.718749 14 0.718748C21.7194 0.718746 28 6.99929 28 14.7187C28 22.4382 21.7214 28.7187 14 28.7187ZM14 1.6679C6.80352 1.6679 0.949153 7.52227 0.949155 14.7187C0.949156 21.9152 6.80353 27.7696 14 27.7696C21.1965 27.7696 27.0508 21.9152 27.0508 14.7187C27.0508 7.52227 21.1965 1.6679 14 1.6679Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1078 19.103L9.61572 18.611L13.5079 14.7188L9.61572 10.8266L10.1078 10.3345L14 14.2267L17.8922 10.3345L18.3843 10.8266L14.4921 14.7188L18.3843 18.611L17.8922 19.103L14 15.2108L10.1078 19.103Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCloseIcon);
export default __webpack_public_path__ + "static/media/CircleCloseIcon.65403b09c01c9a1d2a512acb2865a693.svg";
export { ForwardRef as ReactComponent };